import requests from "./httpServices";

const PricingServices = {
  /**
   * Get pricing for a specific type (school or teacher)
   * @param {string} type - 'school' or 'teacher'
   * @param {string} promoCode - Optional promo code
   * @param {boolean} isFromUrl - Optional flag if promo code is from URL
   */
  getPricing: async (type, promoCode = null, isFromUrl = false) => {
    try {
      let url = `/pricing/${type}`;
      const params = new URLSearchParams();
      
      if (promoCode) {
        params.append('reemcode', promoCode);
      }
      if (isFromUrl) {
        params.append('isFromUrl', 'true');
      }
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      const response = await requests.get(url);
      return response;
    } catch (error) {
      console.error(`Error fetching ${type} pricing:`, error);
      // Return default values if API fails
      const defaults = {
        school: { baseAmount: "9000.00", amount: "9000.00", discountPercent: 0 },
        teacher: { baseAmount: "900.00", amount: "900.00", discountPercent: 0 }
      };
      return defaults[type] || { baseAmount: "0.00", amount: "0.00", discountPercent: 0 };
    }
  },

  /**
   * Get all pricing (school and teacher)
   * @param {string} promoCode - Optional promo code
   * @param {boolean} isFromUrl - Optional flag if promo code is from URL
   */
  getAllPricing: async (promoCode = null, isFromUrl = false) => {
    try {
      let url = "/pricing";
      const params = new URLSearchParams();
      
      if (promoCode) {
        params.append('reemcode', promoCode);
      }
      if (isFromUrl) {
        params.append('isFromUrl', 'true');
      }
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      const response = await requests.get(url);
      return response;
    } catch (error) {
      console.error("Error fetching all pricing:", error);
      // Return default values if API fails
      return {
        school: { baseAmount: "9000.00", amount: "9000.00", discountPercent: 0 },
        teacher: { baseAmount: "900.00", amount: "900.00", discountPercent: 0 }
      };
    }
  }
};

export default PricingServices;

